import React, { Fragment } from 'react'
import { Button, Card, Modal, Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { Emails } from '../../../Common'

export default function EmailsSection({
  emails,
  modalEmailIndex,
  isPacienteCadastrado,
  canAddItems,
  onSetModalEmailIndex,
  onCloseModalEmail,
  setEmail,
  removeEmail,
}) {
  if (!emails.length) return null

  const emailEditDisabled = (email) => !canAddItems || (isPacienteCadastrado && email.id)

  return (
    <Fragment>
      <div className="d-none d-md-block table-responsive paciente-form-list-wrap mb-2">
        <Table hover borderless size="sm" className="paciente-form-list-table mb-0">
          <thead className="border-bottom">
            <tr className="text-muted small">
              <th>#</th>
              <th>E-mail</th>
              <th className="text-right">Ações</th>
            </tr>
          </thead>
          <tbody>
            {emails.map((email, index) => (
              <tr key={index}>
                <td className="text-muted">{index + 1}</td>
                <td className="text-break">{email.endereco || '—'}</td>
                <td className="text-right text-nowrap">
                  <Button
                    type="button"
                    variant="link"
                    className="p-1 mr-1"
                    onClick={() => onSetModalEmailIndex(index)}
                    disabled={emailEditDisabled(email)}
                    title="Editar"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                  {!isPacienteCadastrado && (
                    <Button type="button" variant="link" className="p-1 text-danger" onClick={() => removeEmail(index)} title="Remover">
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <div className="d-md-none">
        {emails.map((email, index) => (
          <Card key={index} className="paciente-email-card border mb-2">
            <Card.Body className="py-2 px-3">
              <div className="d-flex justify-content-between align-items-start">
                <div className="min-w-0 pr-2">
                  <div className="text-muted small mb-0">E-mail {index + 1}</div>
                  <div className="text-break small">{email.endereco || '—'}</div>
                </div>
                <div className="d-flex flex-column align-items-end flex-shrink-0">
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-primary"
                    className="mb-1"
                    onClick={() => onSetModalEmailIndex(index)}
                    disabled={emailEditDisabled(email)}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    Editar
                  </Button>
                  {!isPacienteCadastrado && (
                    <Button type="button" size="sm" variant="outline-danger" onClick={() => removeEmail(index)}>
                      Remover
                    </Button>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
        ))}
      </div>

      <Modal
        show={modalEmailIndex !== null}
        onHide={onCloseModalEmail}
        centered
        dialogClassName="paciente-form-item-modal__dialog paciente-form-item-modal__dialog--compact"
        className="paciente-form-item-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>E-mail {modalEmailIndex !== null ? modalEmailIndex + 1 : ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalEmailIndex !== null && (
            <Emails
              index={modalEmailIndex}
              email={emails[modalEmailIndex]}
              onChange={setEmail}
              disableAll={!canAddItems || (isPacienteCadastrado && !!emails[modalEmailIndex]?.id)}
            />
          )}
        </Modal.Body>
        <Modal.Footer className="border-top-0 pt-0">
          <Button type="button" variant="primary" onClick={onCloseModalEmail}>
            Concluir
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  )
}
